<template>
  <div id="controls">
    <button id="deal-button"  @click="handleGameStart" :disabled="gameStore.gameStarted || gameStore.isResetting || gameStore.showCountdown"> {{ gameStore.finishGame ? 'Play Again' : 'Start' }}</button>
    <template v-if="gameStore.isDiscussionMode">
      <button
        id="check-order-button"
        @click="gameStore.toggleDoneDiscussion"
        :disabled="!gameStore.gameStarted || gameStore.cards.length !== 5 || gameStore.finishGame"
      >
        {{ gameStore.isDoneToggled ? 'Resume Game' : "I'm Done" }}
      </button>
      <!--<button
        id="deal-more-button"
        @click="gameStore.dealMoreCards"
        :disabled="!gameStore.canDealMoreCards || !gameStore.gameStarted || gameStore.cards.length !== 2"
      >
        Deal More
      </button>-->

       <!--<button id="view-tiers" @click="gameStore.toggleTiersVisibility">
        {{gameStore.showTiers ? "Hide Tiers" : "Show Tiers"}}
      </button>-->

      <button id="reset-button" @click="gameStore.resetGame" :disabled="!gameStore.gameStarted || gameStore.isResetting">
        {{ gameStore.isResetting ? 'Resetting...' : 'Reset' }}
      </button>

    </template>
    <template v-else>
      <div id="single-player">
      <button id="finish-button" @click="gameStore.toggleDoneSinglePlayer" :disabled="!gameStore.gameStarted">
        {{ gameStore.isDoneToggled ? 'Resume Game' : "I'm Done" }}
      </button>
      <!--<button id="view-tiers" @click="gameStore.toggleTiersVisibility" :disabled="gameStore.timerRunning || !gameStore.finishGame">
        {{gameStore.showTiers ? "Hide Tiers" : "Show Tiers"}}
      </button>-->

      <button id="reset-button" @click="gameStore.resetGame" :disabled="!gameStore.gameStarted || gameStore.isResetting">
        {{ gameStore.isResetting ? 'Resetting...' : 'Reset' }}
      </button>
    </div>
    </template>
  </div>
</template>

<script setup>
import { useGameStore } from '@/stores/gameStore';


const gameStore = useGameStore();
const handleGameStart = () => {
  if (gameStore.finishGame) {
    gameStore.restartGame();
  } else {
    // Start countdown for new game
    gameStore.startCountdown();
  }
};
</script>